module.exports = __webpack_public_path__ + "img/no-activity.36245a59.webp";